<template>
  <van-overlay :show="show" class="conn_voer">
    <div class="connection-empty">
      <p>只有通过认证的专业买家和参展商才能浏览</p>
      <p>完成认证即可继续浏览</p>
      <van-button class="btn" round color="#f85b0f" @click="gotoAuth" >认证成为专业买家</van-button>
    </div>
  </van-overlay>
</template>

<script>
import {mapGetters, mapActions } from "vuex";

export default {
  name: "connection-empty",
  data() {
    return {
      show:true
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    }),
  },
  methods: {
    ...mapActions({ 
      LinkRegistry: "linkTo/LinkRegistry",
      LinkAuerBach: "linkTo/LinkAuerBach",
    }),
    //申请成为专业买家
    gotoAuth(){
      if(this.userInfo.userRole>0 && this.userInfo.auditState==0){
        this.$toast.fail('认证资料正在审核中，请耐心等待...');
        return 
      }
      if(this.userInfo.userRole>0){
        this.LinkAuerBach();
      }else{
        this.LinkRegistry(1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.conn_voer{
  background: rgba(0,0,0,0.75);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
.connection-empty {
  padding-top: 3.7rem;
  text-align: center;
  font-size: 0.3rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0.98rem;
  p {
    line-height: 1;
    color: #fff;
    font-size: 0.3rem;
    &:first-child{
      margin-bottom: 0.33rem;
    }
  }
  .btn{
    display: block;
    margin: 2.35rem auto 0.3rem;
    height: 0.84rem;
    line-height: 0.84rem;
    width: 3rem;
    text-align: center;
    padding: 0;
    span{
      font-size: 0.3rem;
    }
  }
}
</style>
